import gql from "graphql-tag";
import PostFields from "../../fragments/engagement/PostFields";

export default gql`
  query MostRepliedPosts($contextType: PostContextType!, $top: Int) {
    mostRepliedPosts(contextType: $contextType, top: $top) {
      ...PostFields
    }
  }

  ${PostFields}
`;
